export default __webpack_public_path__ + "static/media/About_v2.20be976c.md";